__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/ba4dd9e50fd7ee18704932d07eb972bc56f7e12fb243681917b4cb94/";